import http from "../../api";

export default {
  namespaced: true,
  actions: {
    technical({}, body) {
      return http.post("/report/technical", body);
    },
    airtime({}, body) {
      return http.post("/report/airtime", body);
    },
    transfers({}, body) {
      return http.post("/report/transfers", body);
    },
    financial({}, body) {
      return http.post("/report/financial", body);
    },
    getTransactionLog({}, body) {
      return http.post("/report/log", body);
    },

    ////QUEUE
    queue({}, body) {
      return http.post("/report/queue", body);
    },
    getTransactionStates() {
      return http.get("/report/queue/states");
    },
    changeTransactionStateFromHistory({},  body){
      return http.put("/report/history", body);
    },
    updateTransactionFromQueue({}, { Id, ...body }) {
      return http.put("/report/queue/" + Id, body);
    },
    deleteTransactionFromQueue({}, { Id }) {
      return http.delete("/report/queue/" + Id);
    },

    getListOfTransaction({}, body){
      return http.post('/report/getalltransaction', body);
    },

    getAllStates({}, body){
      return http.get('/report/queue/states');
    },

    // Bulk operations (only for queue)
    bulkUpdateQueue({}, body) {
      return http.put('/report/queue/bulk', body);
    },
    bulkDeleteQueue({}, body) {
      return http.post('/report/queue/bulk-delete', body);
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/report.js